import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import { Box, CssBaseline, Toolbar, IconButton, List, ListItem, Drawer, ListItemText, Button, Divider, Select, MenuItem, FormControl } from '@mui/material';
import AppBar from "@mui/material/AppBar";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MenuIcon from "@mui/icons-material/Menu";
import Menu from '@mui/material/Menu';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import brandLogo from '../assets/brand-logo.jpg';
import { Link, useNavigate } from 'react-router-dom';
import SideMenuItems from "./SideMenuItems";
import BreadCrumbBar from '../components/BreadCrumbBar';
import { useTranslation } from 'react-i18next';
import languageicon from "../assets/internet-icon.svg";
import '../../src/style/common.css';
import { useLogout } from '../../src/components/Utils';
import { useMsal } from "@azure/msal-react";
import { azureLogOut } from "../store/actions/auth";

const CustomAppBar = styled(AppBar)`
  background-color: #fff!important; 
  color: #FFFBF9;
  box-shadow: 0px 3px 6px #00000029;
`;

const HeaderWrapper = styled.div`
  margin-left: 20px;
  display: flex;
  width: 400px;
  @media (max-width: 1024px) {
    display:none
  }

  @media (min-width:1000px ) and (max-width: 1200px) {
    margin-left: 0;
  }
`;

const Header = ({ authDetails, breadcrumb, showLogo }) => {
  const langs = {
    "en": "English",
    "gr": "German",
    "sp_mex": "Spanish (Mexico)",
    "sp_sp": "Spanish (Spain)",
    "sl": "Slovakia",
    "ch": "Chinese",
    "pr": "Portuguese"
  };

  const { i18n } = useTranslation('common');
  const { t } = useTranslation('common');
  const { instance } = useMsal();

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const userDetails = JSON.parse(window.sessionStorage.getItem("userInfo"));
  const userName = userDetails?.firstName 
  ? `${userDetails.firstName} ${userDetails.middleName ? userDetails.middleName + ". " : ""}${userDetails.lastName || ""}` 
  : t("User");

  const onLogout = useLogout();
  const navigate = useNavigate();
  const activeMenu = window.location.pathname.slice(1).split('/')[0];
  const isRightMenuOpen = Boolean(anchorEl);
  const [language, setLanguage] = useState(userDetails?.langPreference || "en"); // Default language

  useEffect(() => {
    const storedLanguage = sessionStorage.getItem("language") || userDetails?.langPreference || "en";
    setLanguage(storedLanguage);
    i18n.changeLanguage(storedLanguage);
  }, [i18n]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    i18n.changeLanguage(newValue);
    setLanguage(newValue);
    sessionStorage.setItem("language", newValue); // Save to session storage
  };

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);
  const handleMenuClose = () => setAnchorEl(null);
  const handleProfileMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleLogout = () => {
    azureLogOut(instance)
  };
  const handleMailToClick = () => {
    window.open('mailto:mplb@martinrea.com', '_blank');
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <CustomAppBar className="appBar" position="fixed">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ marginRight: 'auto', color: '#686F6F', mr: 2, display: { xs: 'block', sm: 'block', xl: 'block', lg: 'block', md: 'block' } }}
          >
            <MenuIcon />
          </IconButton>
          <div style={{ position: 'relative', top: '5px', cursor: 'pointer' }} onClick={() => { navigate('/home') }}>
            <img height={60} src={brandLogo} alt="logo" />
          </div>
          <HeaderWrapper>
            <BreadCrumbBar label={breadcrumb} />
          </HeaderWrapper>
          <div style={{ marginLeft: 'auto', display: 'flex' }} id="languageMenu" className="lg-device-menu">
          <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleMailToClick}
              style={{ textTransform: 'capitalize', color: "#000" }}
            >
                {t("Contact Us")}
            </Button>
            <FormControl sx={{ m: 1 }}>
              <Select
                labelId="demo-simple-select-label"
                id="language-select"
                label="Language"
                value={language}
                onChange={handleChange}
                renderValue={(value) => (
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <img src={languageicon} alt="language" />
                    {langs[value]}
                  </Box>
                )}
              >
                {Object.keys(langs).map((key) => (
                  <MenuItem key={key} value={key}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <img src={languageicon} alt="language" />
                      {langs[key]}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              style={{ textTransform: 'capitalize', color: "#000" }}
              endIcon={<ArrowDropDownIcon />}
            >
              {t("Hi")} &nbsp;<span style={{ textTransform: 'capitalize', color: "#005974", textOverflow: "ellipsis" }}>{userName}</span>
            </Button>
          </div>
        </Toolbar>
      </CustomAppBar>

      <Drawer
        open={open}
        onClose={handleDrawerClose}
        sx={{
          "& .MuiDrawer-paper": {
            boxShadow: "0px 3px 6px #00000029",
            backgroundColor: '#F0F0F0'
          }
        }}
      >
        <div style={{ padding: "15px 20px", boxShadow: '0px 3px 6px #00000029', height: 120, background: '#fff', textAlign: 'center' }}>
          <img height={60} alt="mass-logo" src={brandLogo} style={{ marginTop: 20 }} />
        </div>
        <List>
          {SideMenuItems.map((menu) => (
            (userDetails?.roleDetails?.code === "MRUSER" ? menu.isBusRoute : menu.isAdminRoute) &&
            <ListItem
              key={menu.route}
              className="sideMenuItem"
              onClick={() => {
                navigate(`/${menu.route}`);
                handleDrawerClose(); // Close the drawer when a menu item is clicked
              }}
              sx={{
                height: "35",
                padding:0,
                  paddingLeft: "10px !important",
                  paddingRight: "10px !important",
                  margin: 0,
                "&.Mui-selected": {
                  color: "#002a57",
                  backgroundColor: "#EDF6F4",
                  minHeight: "35px",
                  margin: 0
                }
              }}
              selected={activeMenu === menu.route || menu.subRoutes.includes(activeMenu)}
            >
              <Link key={menu.route} to={`/${menu.route}`} className='sideMenuLink'>
                        <ListItemText key={menu.route} primary={t(menu.name)} sx={{ '& .MuiTypography-root': { fontFamily: '' } }} />
              </Link>
            </ListItem>
          ))}
        </List>
        <div style={{ marginLeft: 'auto', display: 'flex' }} id="languageMenu" className="mbl-menu">
          <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleMailToClick}
              style={{ textTransform: 'capitalize', color: "#000" }}
            >
                {t("Contact Us")}
            </Button>
            <FormControl sx={{ m: 1 }}>
              <Select
                labelId="demo-simple-select-label"
                id="language-select"
                label="Language"
                value={language}
                onChange={handleChange}
                renderValue={(value) => (
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <img src={languageicon} alt="language" />
                    {langs[value]}
                  </Box>
                )}
              >
                {Object.keys(langs).map((key) => (
                  <MenuItem key={key} value={key}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <img src={languageicon} alt="language" />
                      {langs[key]}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              style={{ textTransform: 'capitalize', color: "#000" }}
              endIcon={<ArrowDropDownIcon />}
            >
              {t("Hi")} &nbsp;<span style={{ textTransform: 'capitalize', color: "#005974", textOverflow: "ellipsis" }}>{userName}</span>
            </Button>
          </div>
      </Drawer>

      <Menu
        style={{ marginTop: "40px" }}
        className="profile-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={isRightMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem className="s-bold" onClick={() => { navigate('/profile') }}>{t("My Profile")}</MenuItem>
        <Divider />
        <MenuItem className="s-bold" onClick={handleLogout}>{t("Logout")}</MenuItem>
      </Menu>
    </Box>
  );
};

const mapStateToProps = (state) => ({ authDetails: state.auth, breadcrumb: state.breadcrumbs });

export default connect(mapStateToProps, null)(Header);

Header.propTypes = {
  authDetails: PropTypes.object.isRequired,
  breadcrumb: PropTypes.object.isRequired,
};
